const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.valeglobal.forwoodsafety.com',
    USER_TOKEN_URL: 'https://fgsyhlg3j3.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://dpso4xv1y8.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.valeglobal.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.valeglobal.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.valeglobal.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.valeglobal.forwoodsafety.com',
    WEBSOCKET: 'wss://opv2fciaaf.execute-api.us-west-2.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
